var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.847,
    height: 23.491,
    viewBox: "0 0 22.847 23.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flight",
    transform: "translate(-6.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8269",
    "data-name": "Group 8269",
    transform: "translate(6.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M26.007,8.932q-2.236,0-4.473.065l-6.3-9H11.913l4.245,9.209q-2.631.133-5.262.315L8.255,4.88H6.482l1.7,4.841a1.871,1.871,0,0,0-1.573,2.024A1.871,1.871,0,0,0,8.18,13.769l-1.7,4.842H8.255L10.9,13.965q2.63.181,5.261.317l-4.245,9.209h3.321l6.3-9q2.238.06,4.474.066a3.165,3.165,0,0,0,3.322-2.809v-.008A3.16,3.16,0,0,0,26.007,8.932Z",
    transform: "translate(-6.482)",
    fill: "#ff8700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.41ae44ac429ea934165b1466c1c2cbe5.svg";
export { ForwardRef as ReactComponent };